// Generic educational prompts only. Trust-specific questions require their own
// clinical approval and Studio publication workflow before they can be shown.
const BEFORE_DAY_SURGERY = Object.freeze([
  { id: 'fasting', stageId: 'before', textKey: 'fasting', allowNotApplicable: false },
  { id: 'medicines', stageId: 'before', textKey: 'medicines', allowNotApplicable: true },
  { id: 'arrival', stageId: 'before', textKey: 'arrivalDay', allowNotApplicable: false },
  { id: 'transport', stageId: 'before', textKey: 'transport', allowNotApplicable: true },
  { id: 'home-support', stageId: 'before', textKey: 'homeSupport', allowNotApplicable: true },
  { id: 'aftercare-contact', stageId: 'home', textKey: 'aftercareContact', allowNotApplicable: false },
]);

const BEFORE_INPATIENT_SURGERY = Object.freeze([
  { id: 'fasting', stageId: 'preparing', textKey: 'fasting', allowNotApplicable: false },
  { id: 'medicines', stageId: 'preparing', textKey: 'medicines', allowNotApplicable: true },
  { id: 'arrival', stageId: 'preparing', textKey: 'arrivalInpatient', allowNotApplicable: false },
  { id: 'transport', stageId: 'preparing', textKey: 'transport', allowNotApplicable: true },
  { id: 'discharge-support', stageId: 'preparing', textKey: 'dischargeSupport', allowNotApplicable: true },
  { id: 'aftercare-contact', stageId: 'recovery', textKey: 'aftercareContact', allowNotApplicable: false },
]);

export function getPreparationChecklistItems(journey) {
  // Do not automatically add new clinical-facing content to a Trust-published
  // Journey, an Easy Read layout, or a preview awaiting local approval.
  if (!journey || journey.trustId !== 'generic_nhs' || journey.easyRead) return [];
  if (journey.templateId === 'day-surgery') return BEFORE_DAY_SURGERY;
  if (journey.templateId === 'surgery-operation') return BEFORE_INPATIENT_SURGERY;
  return [];
}

export function itemsForPreparationStage(items, stageId) {
  return items.filter((item) => item.stageId === stageId);
}
